import {texture, spine, MiniSignal} from "p3";
import common from "../common";
import definitions from "../definitions";
import GameScene from "./GameScene";
import MenuScene from "./MenuScene";
import screenfull from 'screenfull';
import { iswebfont, getRandomFloat, locale, resizeLabelToFitText, convertAr } from "../utils";
import settings from "../settings";
import { Skin } from "@pixi-spine/runtime-4.1";

export default class SplashScene extends MenuScene {
    constructor() {
        super("splash");

        this._animationLayer = null;
        this._logo = null;
        this._titleBg = null;
        this._ivandoe = null;
        this._bert = null;

        this._muteButton = null;
        this._continueButton = null;
        this._newButton = null;
        this._footer = null;
        this._playButton = null;
        this._newGameMode = false;
        this._charSnake = null;

        this._completedMessageMode = false;

        this.signals.settings = new MiniSignal();
    }

    destroy() {
        this._continueButton.destroy();
        this._newButton.destroy();
        this.removeAllTweens(true);
        super.destroy();
    }

    addSceneLoader(manifest, title) {
        
        manifest.push({ name: "game_logo", url: "images/localization/" + common.config.language + "/logo_game_title_" + common.config.language + ".png" })
        return super.addSceneLoader(manifest, title);
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        if (common.saveData.isActiveSlotEmpty() || settings.PHASE > 1) {
            this._newGameMode = true;
        }

        P3.audio.playMusic("music_splash_loop_00");
        if (common.saveData.settings.musicMute) {
            P3.audio.music.pause();
        }

        const bg = new PIXI.Sprite(texture("splash_bg_1x"));
        bg.width = common.STAGE_WIDTH;
        this.addChild(bg);

        this._animationLayer = new PIXI.Container();
        this.addChild(this._animationLayer);

        this._logo = new PIXI.Sprite(texture("logo_show"));
        this._logo.position.set(common.STAGE_WIDTH * 0.5, 164);
        this._logo.anchor.set(0.5);
        this.addChild(this._logo);

        this._titleBg = new PIXI.Sprite(texture("logo_game_bg"));
        this._titleBg.position.set(common.STAGE_WIDTH * 0.5, 314);
        this._titleBg.anchor.set(0.5);
        this.addChild(this._titleBg);

        this._titleLogo = new PIXI.Sprite(texture("game_logo"));
        //this._titleLogo.position.set(common.STAGE_WIDTH * 0.5, 314);
        this._titleLogo.anchor.set(0.5);
        this._titleBg.addChild(this._titleLogo);

        let states;

        states = new P3.ButtonStates(texture("btn_small_out"));
        states.icon = texture("btn_icon_sound_on");
        states.iconAlt = texture("btn_icon_sound_off");

        if (settings.APP) {
            this._settingsButton = P3.Button.create(
                texture("btn_small_out"),
                texture("btn_small_out"),
                texture("btn_small_out"),
                texture("btn_icon_settings"),
            );
            this._settingsButton.signals.click.add(this.onSettingsButtonClick, this);
            this.addChild(this._settingsButton);
        } else {
            this._muteButton = new P3.MuteButton(states);
            this.signalListeners.push(this._muteButton.signals.click.add(() => {
                common.saveData.settings.muted = !this._muteButton.isEnabled();
                common.saveData.saveGame();

                // tracking
                let interaction = !common.saveData.settings.muted ? "sound on" : "sound off";
                common.tracking.trackEvent(definitions.TRACKING.EVENT_TYPE.INTERACTION, {
                    section: common.tracking.getSection(),
                    contenttitle: interaction,
                    interaction: interaction,
                    progress: common.tracking.progress,
                    interactionevent: 1
                });
            }, this));
            this.addChild(this._muteButton);
        }

        states = new P3.ButtonStates(texture("btn_rectangle_out"));

        this._continueButton = new P3.Button(states);
        this._continueButton.overSoundName = "sfx_btn_generic_rollover";
        this._continueButton.clickSoundName = "sfx_btn_generic_press_00";
        this._continueButton.position.set(common.STAGE_WIDTH * 0.5, 533);
        this._continueButton.signals.click.add(this.onContinueButtonClick, this);
        this.addChild(this._continueButton);
        let arrow = new PIXI.Sprite(texture("btn_icon_play_medium"));
        arrow.anchor.set(0.5);
        arrow.x = 100;
        this._continueButton._icon.addChild(arrow);

        let nameLabel;
        if (!iswebfont()) {
            nameLabel = new PIXI.BitmapText(locale(this._newGameMode ? 'ui_splash_new_game' : 'ui_splash_continue').toUpperCase(), {
                fontName: "Alghera Pro Outline",
                fontSize: 32,
                align: "left",
                tint: 0xFFFFFF
            });
        } else {
            nameLabel = new PIXI.Text(locale(this._newGameMode ? 'ui_splash_new_game' : 'ui_splash_continue').toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 32,
                align: "left",
                fill: 0x0
            });
        }

        nameLabel.position.set(-120, 0);
        nameLabel.anchor.set(0, 0.5);
        this._continueButton._background.addChild(nameLabel);
        resizeLabelToFitText(nameLabel, 180);

        this._newButton = new P3.Button(states);
        this._newButton.overSoundName = "sfx_btn_generic_rollover";
        this._newButton.clickSoundName = "sfx_btn_generic_press_00";
        this._newButton.position.set(common.STAGE_WIDTH * 0.5, 610);
        this._newButton.signals.click.add(this.onNewButtonClick, this);
        this.addChild(this._newButton);
        arrow = new PIXI.Sprite(texture("btn_icon_play_medium"));
        arrow.anchor.set(0.5);
        arrow.x = 100;
        this._newButton._icon.addChild(arrow);

        if (!iswebfont()) {
            nameLabel = new PIXI.BitmapText(locale('ui_splash_new_game').toUpperCase(), {
                fontName: "Alghera Pro Outline",
                fontSize: 32,
                align: "left",
                tint: 0xFFFFFF
            });
        } else {
            nameLabel = new PIXI.Text(locale('ui_splash_new_game').toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 32,
                align: "left",
                fill: 0x0
            });
        }

        nameLabel.position.set(-120, 0);
        nameLabel.anchor.set(0, 0.5);
        this._newButton._background.addChild(nameLabel);
        resizeLabelToFitText(nameLabel, 180);

        this._footer = new PIXI.NineSlicePlane(texture("panel_game_completed_9slice"), 30, 30, 30, 30);
        this._footer.y = common.STAGE_HEIGHT - 95;
        this.addChild(this._footer);

        const mainQuestResult = common.saveData.activeSlot.quests['queen_kristine|quest_1'] || this._completedMessageMode;
        const complete = mainQuestResult === true || mainQuestResult == 4;

        if (!iswebfont()) {
            this._footerText = new PIXI.BitmapText(locale(complete ? 'ui_splash_continue_description_complete' : 'ui_splash_continue_description_incomplete'), {
                fontName: "Alghera Pro",
                fontSize: 28,
                align: "center",
                tint: 0x000000
            });
        } else {
            this._footerText = new PIXI.Text(locale(complete ? 'ui_splash_continue_description_complete' : 'ui_splash_continue_description_incomplete'), {
                fontFamily: "FredFredBurger",
                fontSize: 28,
                align: "left",
                fill: 0x0
            });
        }

        this._footerText.anchor.set(0, 0.5);
        this._footerText.position.set(this._footer.width/2, 30);

        this._footer.addChild(this._footerText);
    
        const allQuestsComplete =  common.saveData.activeSlot.quests['queen_kristine|quest_1'] == true && 
                                   common.saveData.activeSlot.quests['nanny|quest_1'] == true && 
                                   common.saveData.activeSlot.quests['king_knut|quest_1'] == true;

        if (settings.PHASE >= 2 && !allQuestsComplete) {
            this._footerText.text = locale("ui_splash_new_quests");
            this._footer.visible = true;
        }
        
        resizeLabelToFitText(this._footerText, 800);

        this._footer.width = this._footerText.width + 80;
        this._footer.x = (common.STAGE_WIDTH/2) - (this._footer.width/2);
        this._footerText.x = 40;

        let playButtonStates;
        playButtonStates = new P3.ButtonStates(texture("btn_action_large_out"));
        playButtonStates.icon = texture("btn_icon_large_play");

        this._playButton = new P3.Button(playButtonStates);
        this._playButton.overSoundName = "sfx_btn_generic_rollover";
        this._playButton.clickSoundName = "sfx_btn_generic_press_00";
        this._playButton.position.set(common.STAGE_WIDTH * 0.5, 563);
        this._playButton.signals.click.add(this.onPlayClick, this);
        this._playButton.visible = false;
        this.addChild(this._playButton);

        if (this._newGameMode) {
            if (settings.PHASE < 2) {
                this._footer.visible = false; 
            }

            this._newButton.visible = false;
            this._continueButton.visible = false;
            this._playButton.visible = true;
        }

        if (this._completedMessageMode && settings.PHASE < 2) {
            this._footer.visible = true;
        }

        if (settings.APP && this._footerText.text == locale("ui_splash_new_quests")) {
            this._footer.visible = false;
        }

        this._startAnimations();

        this.resize();
    }

    update() {
        super.update();
        if(this.isSceneLoaded) {
            this._ivandoe.update(window.dt);
            this._bert.update(window.dt);
            this._charSnake.update(window.dt);
        }
    }

    resize() {
        super.resize();

        if (this.isSceneLoaded) {
            this.resizeFill();
            if (this._settingsButton) {
                this._settingsButton.position.set(
                    (common.STAGE_WIDTH + P3.View.width - this._settingsButton.width) * 0.5 - this.buttonMargin.width,
                    this._settingsButton.height * 0.5 + this.buttonMargin.y
                )
            } else if (this._muteButton) {
                this._muteButton.position.set(
                    (common.STAGE_WIDTH + P3.View.width - this._muteButton.width) * 0.5 - this.buttonMargin.width,
                    this._muteButton.height * 0.5 + this.buttonMargin.y
                )
            }
        }
    }

    pauseTweens() {
        super.pauseTweens();
        if (this._settingsButton) {
            this._settingsButton.visible = false;
        }
    }

    resumeTweens() {
        super.resumeTweens();
        if (this._settingsButton) {
            this._settingsButton.visible = true;
        }
    }

    _startAnimations(){

        const charBoaris = new PIXI.Sprite(texture('char_boaris'));
        charBoaris.position.set(775, 496);
        this._animationLayer.addChild(charBoaris);

        const charGnome = new PIXI.Sprite(texture('char_gnome'));
        charGnome.position.set(448, 569);
        this._animationLayer.addChild(charGnome);

        const charSwan = new PIXI.Sprite(texture('char_swan'));
        charSwan.position.set(333, 104);
        this._animationLayer.addChild(charSwan);
        
        const overlays = [
            'char_boaris_overlay',
            'char_gnome_overlay',
            'char_swan_overlay'];

        for (let i in overlays) {
            let spr = new PIXI.Sprite(texture(overlays[i]));
            this._animationLayer.addChild(spr);
        }

        this._charSnake = new PIXI.spine.Spine(spine("enemy_flying_snake"));
        this._charSnake.autoUpdate = false;
        this._charSnake.position.set(0, 370);
        this._charSnake.rotation = 5 * PIXI.DEG_TO_RAD;
        this._charSnake.scale.set(0.6);
        this._charSnake.state.setAnimation(0, 'idle_00', true);
        this._animationLayer.addChild(this._charSnake);

        this._tweens.push(gsap.to(charBoaris, 0.4, {delay:1, y:395, ease:Back.easeOut}));
        this._tweens.push(gsap.to(charGnome, 0.6, {delay:1.3, y:440, ease:Sine.easeOut}));
        this._tweens.push(gsap.to(charSwan, 0.3, {delay:1.6, x:422, ease:Expo.easeOut}));

        this._tweens.push(gsap.to(charBoaris.scale, 1.8, {delay:1, x: 1.02, y:1.02, ease:Power0.easeOut, yoyo:true, repeat: Infinity}));
        this._tweens.push(gsap.to(charGnome.scale, 1.7, {delay:1.3, x: 1.02, y:1.02, ease:Power0.easeOut, yoyo:true, repeat: Infinity}));
        this._tweens.push(gsap.to(charSwan.scale, 1.9, {delay:1.6, x:1.02, y:1.02, ease:Power0.easeOut, yoyo:true, repeat: Infinity}));

        this._tweens.push(gsap.to(this._charSnake, 1, {delay:1.5, x:600, ease:Sine.easeOut}));
        this._tweens.push(gsap.to(this._charSnake, 1, {y:390, yoyo:true, repeat:-1, ease:Sine.easeInOut}));
        this._tweens.push(gsap.to(this._charSnake, 0.9, {rotation:-5*PIXI.DEG_TO_RAD, yoyo:true, repeat:-1, ease:Sine.easeInOut}));

        const charBoarisTimeline = gsap.timeline({repeatRefresh: true, repeat: -1, repeatDelay: getRandomFloat(5, 10)});
        this._tweens.push(charBoarisTimeline.to(charBoaris, { y: 480 }));
        this._tweens.push(charBoarisTimeline.to(charBoaris, { y: 395, delay: getRandomFloat(1, 5) }));

        const charGnomeTimeline = gsap.timeline({repeatRefresh: true, repeat: -1, repeatDelay: getRandomFloat(7, 12)});
        this._tweens.push(charGnomeTimeline.to(charGnome, { y: 559 }));
        this._tweens.push(charGnomeTimeline.to(charGnome, { y: 440, delay: getRandomFloat(1, 5) }));

        const charSwanTimeline = gsap.timeline({repeatRefresh: true, repeat: -1, repeatDelay: getRandomFloat(3, 8)});
        this._tweens.push(charSwanTimeline.to(charSwan, { x: 333 }));
        this._tweens.push(charSwanTimeline.to(charSwan, { x: 422, delay: getRandomFloat(1, 5) }));

        this._ivandoe = new PIXI.spine.Spine(spine("char_ivandoe"));
        this._ivandoe.skeleton.setSlotsToSetupPose();
        this._ivandoe.skeleton.setToSetupPose();
        this._ivandoe.autoUpdate = false;
        this._ivandoe.state.setAnimation(0, 'splash_idle_01', true);
        this._ivandoe.position.set(1200, 720);
        this._ivandoe.scale.set(-0.5, 0.5);
        this._animationLayer.addChild(this._ivandoe);

        const skin = new Skin("ivandoe_stance_normal");
        skin.addSkin(this._ivandoe.spineData.findSkin("normal"));
        skin.addSkin(this._ivandoe.spineData.findSkin("equip_sword"));
        skin.addSkin(this._ivandoe.spineData.findSkin("outfit_standard"));
        skin.addSkin(this._ivandoe.spineData.findSkin("belt_standard"));

        this._ivandoe.skeleton.setSkin(skin);
        this._ivandoe.skeleton.setSlotsToSetupPose();

        this._bert = new PIXI.spine.Spine(spine("char_bert"));
        this._bert.skeleton.setSlotsToSetupPose();
        this._bert.skeleton.setToSetupPose();
        this._bert.autoUpdate = false;
        this._bert.state.setAnimation(0, 'idle_00', true);
        this._bert.position.set(1200, 300);
        this._bert.scale.set(-0.5, 0.5);
        this._animationLayer.addChild(this._bert);

        this._tweens.push(gsap.to(this._bert, 2.5, {x:1250, yoyo:true, repeat:-1, ease:Sine.easeInOut}));

        this._logo.scale.set(0);
        this._titleBg.scale.set(0);

        this._tweens.push(gsap.to(this._logo.scale, 0.5, {delay:0.5, x:1, y:1, ease:Sine.easeOut}));
        this._tweens.push(gsap.to(this._titleBg.scale, 0.5, {delay:1, x:1, y:1, ease:Sine.easeOut}));
    }

    onContinueButtonClick() {
        if (screenfull.isEnabled && PIXI.utils.isMobile.android.device) {
            screenfull.request();
        }
        this.signals.next.dispatch();
    }

    onPlayClick() {
        if (screenfull.isEnabled && PIXI.utils.isMobile.android.device) {
            screenfull.request();
        }
        if (settings.PHASE == 1) {
            common.saveData.createEmptySlot(common.saveData.activeSlot.id, true);
            common.saveData.setActiveSlot(0);
        }
        /*
        console.log('callAd 1');
        if (settings.APP) {
            
            function callAd() {
                console.log('CALLING AD');
                const rewarded = new admob.RewardedAd({
                    adUnitId: 'ca-app-pub-3940256099942544/5224354917',
                })
                
                console.log('rewarded');

                rewarded.on('load', (evt) => {
                    console.log('rewarded.show()');
                    rewarded.show();
                });

                rewarded.on('reward', () => {
                    console.log('on ad watched');
                });
                
                rewarded.load();                
            }

            admob.start()
            .then(() => {
                console.log('admob started');
                admob.configure({
                testDeviceIds: ['33BE2250B43518CCDA7DE426D04EE231'],
            })})
            .then(() => {
                console.log('starting to call ad');
                callAd()
            })
            .then(() =>
                admob.BannerAd.config({
                backgroundColor: '#A7A7A7',
                marginTop: 10,
                marginBottom: 10,
                }),
            )
            .catch(alert)

            console.log('callAd 2');
        }
        */

        this.signals.next.dispatch();
    }

    onNewButtonClick() {
        if (screenfull.isEnabled && PIXI.utils.isMobile.android.device) {
            screenfull.request();
        }

        this._newButton.visible = this._newButton.interactive = false;
        this._continueButton.visible = this._continueButton.interactive = false;

        this._fill = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._fill.tint = 0x000000;
        this._fill.alpha = 0;
        this.addChild(this._fill);
        this.resizeFill();

        const panel = new PIXI.NineSlicePlane(texture("panel_popup_9slice"), 80, 110, 80, 80);
        panel.width = 470;
        panel.height = 310;
        panel.x = (common.STAGE_WIDTH/2) - (panel.width/2);
        panel.y = common.STAGE_HEIGHT;
        this.addChild(panel);

        let title;
        if (!iswebfont()) {
            title = new PIXI.BitmapText(locale('ui_splash_delete_confirm_title'), {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
        } else {
            title = new PIXI.Text(locale('ui_splash_delete_confirm_title'), {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
        }
        title.anchor.set(0.5);
        title.position.set(panel.width/2, 60);
        panel.addChild(title);
        resizeLabelToFitText(title, panel.width-60);

        let description;
        if (!iswebfont()) {
            description = new PIXI.BitmapText(locale('ui_splash_delete_confirm_description'), {
                fontName: "Alghera Pro",
                fontSize: 30,
                align: "left",
                tint: 0x702311,
                maxWidth: panel.width-60
            });
        } else {
            description = new PIXI.Text(locale('ui_splash_delete_confirm_description'), {
                fontName: "Alghera Pro",
                fontSize: 30,
                align: "left",
                tint: 0x702311,
                maxWidth: panel.width-60
            });
        }
        description.position.set(30, 130);
        panel.addChild(description);

        panel.height = Math.max(panel.height, description.y + description.height + panel.bottomHeight);

        const hidePanel = (callback) => {
            this._tweens.push(
                gsap.to(panel, 0.3, {y:common.STAGE_HEIGHT, ease:Expo.easeIn, onComplete:() => {
                    if (callback) {
                        callback();
                    }
                }}),
                gsap.to(this._fill, 0.2, {alpha:0, ease:Sine.easeIn, onComplete:() => {
                    this._newButton.interactive = true;
                    this._continueButton.interactive = true;
                }})
            );
        }

        const crossButton = P3.Button.create(
            texture("btn_action_medium_out"),
            null,
            null,
            texture("btn_icon_medium_cross")
        );
        crossButton.signals.click.add(() => {
            hidePanel();
            this._newButton.visible = true;
            this._continueButton.visible = true;
        }, this);
        crossButton.x = (panel.width/2) - 150;
        crossButton.y = panel.height;
        panel.addChild(crossButton);

        const tickButton = P3.Button.create(
            texture("btn_action_medium_out"),
            null,
            null,
            texture("btn_icon_medium_tick")
        );
        tickButton.signals.click.add(() => {
            common.saveData.createEmptySlot(common.saveData.activeSlot.id, true);
            common.saveData.setActiveSlot(0);
            hidePanel(() => {
                this.signals.next.dispatch();
            });
        }, this);
        tickButton.x = (panel.width/2) + 150;
        tickButton.y = panel.height;
        panel.addChild(tickButton);

        this._tweens.push(
            gsap.to(panel, 0.3, {y:(common.STAGE_HEIGHT / 2) - (panel.height/2), ease:Expo.easeOut}),
            gsap.to(this._fill, 0.2, {alpha:0.3, ease:Sine.easeIn})
        );
    }

    onSettingsButtonClick() {
        this.signals.settings.dispatch();
    }

    resizeFill(){
        if (this._fill) {
            this._fill.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
            this._fill.width = P3.View.width;
            this._fill.height = P3.View.height;
        }
    }

    set completedMessageMode(value) {
        this._completedMessageMode = value;
    }
}